var tabsContent = document.getElementById("features-gallery-holder");
if (tabsContent) {
  bsTabs(tabsContent);
}
